import { handleResponse, authHeader, handleFileResponse } from '../helpers';

const BASE_URL = process.env.REACT_APP_API_URL;

export const logService = {
    getLogs,
    getDailyExport,
};

function getDailyExport() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/reports/export` , requestOptions)
        .then(handleFileResponse)
        .then( blob => {
            var file = window.URL.createObjectURL(blob);
            return file;
        })
        .catch(err => {
            console.error(err)
        });
}


function getLogs(start) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/call/logs?start=${start}` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}
